<div class="sustainability-card">
    <div class="sustainability-card-frame">
        <div class="card-frame-icon">
            <img src="./assets/img/images/sustainability-icon.svg" class="stuffer-sustainability-image" alt="sustainability icon" />
        </div>
        <div class="card-frame-content">
            <div class="card-frame-title dm-sans-medium">{{"Thank you for helping Mapfre build a more sustainable future."}}</div>
            <div class="card-frame-desc">{{"We are playing our part to improve the management of our environmental footprint.
                Want to know more about our sustainability initiatives?"}}
                <div><a href="https://www.mapfreinsurance.com/social-responsibility-policy" target="_blank" class="mapfre link stuffer-underline red-link dm-sans-medium "> Learn more </a></div>
            </div>
        </div>
    </div>
</div>